import { render, staticRenderFns } from "./systemManagement.vue?vue&type=template&id=b5307b4c&"
import script from "./systemManagement.vue?vue&type=script&lang=js&"
export * from "./systemManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports